export * from './convLayer';
export * from './depthwiseSeparableConv';
export * from './disposeUnusedWeightTensors';
export * from './extractConvParamsFactory';
export * from './extractFCParamsFactory';
export * from './extractSeparableConvParamsFactory';
export * from './extractWeightEntryFactory';
export * from './extractWeightsFactory';
export * from './getModelUris';
export * from './types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/common/index.js
// module id = 67
// module chunks = 0